import type { IconName } from '@raiadrogasil/pulso-icons'
import { Button, type ButtonProps } from '~/components/button'
import { useInputCounterContext } from '../../input-counter'
import type {
  InputCounterScopedProps,
  TInputCounterProps,
} from '../../input-counter.types'

type InputCounterButtonProps = Omit<
  ButtonProps,
  'variant' | 'size' | 'children'
> & {
  symbol?: IconName
}
const InputCounterButton = (props: InputCounterButtonProps) => {
  const { symbol, __scopeInputCounter } =
    props as InputCounterScopedProps<InputCounterButtonProps>

  const { size } = useInputCounterContext(
    'InputCounterButton',
    __scopeInputCounter
  )

  const mapSizeToButtonSize = (size: TInputCounterProps['size']) => {
    const sizeMap: Record<
      NonNullable<ButtonProps['size']>,
      'md' | 'ml' | 'lg' | 'xl'
    > = {
      md: 'md',
      ml: 'md',
      lg: 'ml',
      xl: 'ml',
    }

    return sizeMap[size]
  }

  return (
    <Button.Root
      {...props}
      variant="neutral-tertiary"
      size={mapSizeToButtonSize(size || 'md')}
    >
      <Button.Icon symbol={symbol} />
    </Button.Root>
  )
}

export const InputCounterDecrement = (props: InputCounterButtonProps) => {
  const { __scopeInputCounter, onClick } =
    props as InputCounterScopedProps<InputCounterButtonProps>

  const { setCurrentValue, currentValue, disabled, readOnly } =
    useInputCounterContext('InputCounterButton', __scopeInputCounter)

  return (
    <InputCounterButton
      {...props}
      symbol={currentValue === 1 ? 'rdicon-delete' : 'rdicon-minus'}
      tabIndex={0}
      onClick={event => {
        if (currentValue > 0) {
          setCurrentValue(currentValue - 1)
        }
        onClick?.(event)
      }}
      disabled={disabled || readOnly || currentValue === 0}
    />
  )
}
export const InputCounterIncrement = (props: InputCounterButtonProps) => {
  const { __scopeInputCounter, onClick } =
    props as InputCounterScopedProps<InputCounterButtonProps>

  const { setCurrentValue, currentValue, disabled, readOnly } =
    useInputCounterContext('InputCounterButton', __scopeInputCounter)

  return (
    <InputCounterButton
      {...props}
      symbol={'rdicon-plus'}
      tabIndex={0}
      onClick={event => {
        if (currentValue >= 0 && currentValue < 999) {
          setCurrentValue(currentValue + 1)
        }
        onClick?.(event)
      }}
      disabled={disabled || readOnly || currentValue === 999}
    />
  )
}
